import styled from 'styled-components';
import { Text } from 'components';
import { Color } from '@bb/elements-web-rebranding';

export const StyledNoContent = styled(Text)`
  color: ${Color.SECONDARY_TEXT};
`;

export const StyledBillingDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
`;

export const StyledContainer = styled.div`
  margin-bottom: 16px;
  border: 1px solid ${Color.LIGHTER_GREY};
  border-radius: 4px;
  display: flex;
  padding: 16px;
  width: 100%;
`;

export const StyledBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EditContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledHeader = styled(Text)`
  color: ${Color.PRIMARY_TEXT};
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  margin-bottom: 8px;
`;

export const StyledDescription = styled(Text)`
  color: ${Color.PRIMARY_TEXT};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
`;

export const EditTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
`;

export const CloseCircleButtonStyle = {
  width: 32,
  height: 32,
  maxWidth: 32,
  minWidth: 32,
  gap: 8,
  padding: 0,
  borderColor: Color.BORDER_GREY,
  marginLeft: 24,
};

export const SaveButtonWidth = {
  width: 73,
  height: 40,
  maxWidth: 73,
  minWidth: 73,
};
